module.exports = __webpack_public_path__ + "img/digital-marketing.fc6a35eb.png";